import { Settings as SettingsType } from '@anispi-reporting-system/types';
import { Box } from '@mui/material';
import { endOfMonth, format, subMonths } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import React, { memo, useEffect, useState } from 'react';
import { getSettings } from '../lib/ApiSettings';

const today = utcToZonedTime(new Date(), 'Asia/Tokyo');
const endOfMonthDate = format(endOfMonth(today), 'd');

// eslint-disable-next-line react/display-name
const ReportTerm = memo(() => {
  const [settings, setSettings] = useState<SettingsType | undefined>(undefined);
  const reportDate = subMonths(today, 1);

  useEffect(() => {
    (async () => {
      const settingsResult = await getSettings();
      if (settingsResult.success) {
        setSettings(settingsResult.settings);
      }
    })();
  }, []);

  return (
    <Box className="py-2">
      <Box className="flex h-10 flex-row justify-center space-x-2 border-y border-black p-2 font-semibold text-red-500">
        <p>売上対象月：{`${format(reportDate, 'yyyy')}年${format(reportDate, 'MM')}月`}</p>
        {settings && (
          <p>
            レポート受付期間 ：
            {`${format(today, 'yyyy')}年${format(today, 'MM')}月${settings.openTimeSetting.open.date
              .toString()
              .padStart(2, '0')}日〜${Math.min(settings.openTimeSetting.close.date, parseInt(endOfMonthDate, 10))
              .toString()
              .padStart(2, '0')}日まで`}
          </p>
        )}
      </Box>
    </Box>
  );
});

export { ReportTerm };
